export default {
  banners: {
    items: {
      text: {
        'ui:widget': 'EditorMarkdownWidget',
      },
      textColor: {
        'ui:widget': 'BaseColorWidget',
      },
      linkColor: {
        'ui:widget': 'BaseColorWidget',
      },
      bgImage: {
        'ui:widget': 'EditorUploadWidget',
      },
      bgColor: {
        'ui:widget': 'BaseColorWidget',
      },
      mobileBgImage: {
        'ui:widget': 'EditorUploadWidget',
      },
      mobileBgColor: {
        'ui:widget': 'BaseColorWidget',
      },
      mediumBgImage: {
        'ui:widget': 'EditorUploadWidget',
      },
      mediumBgColor: {
        'ui:widget': 'BaseColorWidget',
      },
      buttons: {
        items: {
          color: {
            'ui:widget': 'BaseColorWidget',
          },
          textColor: {
            'ui:widget': 'BaseColorWidget',
          },
        },
      },
    },
  },
}
